import axios from "axios";
import type { AxiosResponse } from "axios";
import GetSign from '@tencent/wand_lib_intel_sign'
import message, { MessageType } from "@/utils/message";
import LOGIN from "@/utils/login";
import { account_type } from "@/utils/const";

export const request = axios.create({
	baseURL: "",
	timeout: 40000, // 设置超时时长
});
const combineLogin = async (loginParam: Record<string, any>, needLogin: boolean) => {
	// 检查登录态
	const logined = await LOGIN.checkLogin();
	if (logined) {
		return LOGIN.info();
	} 
	if (needLogin) {
		loginPage(loginParam);
	}
	return false;
}
async function loginPage(loginParam: Record<string, any>) {
	try {
		const result = await LOGIN.showLogin({
			...loginParam,
		});
		if (!result) return;
		window.location.reload();
	} catch (e) {
		console.log("登录模块需要先在模板中初始化", e);
	}
}
const joinSearchParams = (searchA: URLSearchParams, searchB: URLSearchParams) => {
		if (!searchA) return searchB;
		if (!searchB) return searchA;
		for (const [key, value] of Array.from(searchA.entries())) {
			searchB.append(key, value);
		}
  return searchB;
};
request.interceptors.request.use(
	async (rawConfig) => {
		const {
      checkLogin = true,
      needLogin = true,
      loginParam = {}, // 登录配置项
      ...resetPostData // 剩余的是post请求的真实参数
    } = rawConfig.data;
		if (!checkLogin) {
			// const newconfig = GetSign({
			const newconfig = ({
				...rawConfig,
				data: resetPostData,
			});
			return newconfig;
		}
		const res = await combineLogin(loginParam, needLogin);
		if (res === false) {
			// 未登录
			throw new axios.Cancel("not login,cancel request");
		}
		try {
			const result = new URLSearchParams(res || {});
			const { origin, pathname, searchParams } = new URL(rawConfig.url!);
			const fullSearch = joinSearchParams(result, searchParams);
			fullSearch.append("account_type", account_type);
			const fullPath = `${origin}${pathname}?${fullSearch.toString()}`;
			const newconfig = GetSign({
				// const newconfig = ({
				...rawConfig,
				url: fullPath,
				data: resetPostData,
			});
			return newconfig;
		} catch (error) {
			throw new axios.Cancel(error as string);
		}
	},
	(err) => {
		const { response } = err;
		if (response) {
			checkStatus(response);
		}
		return Promise.reject(err);
	}
)
request.interceptors.response.use(
	async (res) => {
		if (res.status === 200) {
			checkBackendStatus(res);
			return Promise.resolve(res);
		}
		checkStatus(res);
		return Promise.reject(res);
	},
	(err) => {
		const { message: msg, name } = err;
		message({
			type: MessageType.Warning,
			text: `${name}: ${msg}`,
		})
		return Promise.reject(err);
	}
);

const checkStatus = (response: AxiosResponse) => {
	if (response.status >= 200 && response.status < 300) {
		return response;
	}
	const errortext = 'erro de rede';
	message({
		type: MessageType.Warning,
		text: errortext,
	})
	return response;
};

const BackendErroCode = {
	// SendPhoneCodeTooFast 发送验证码过快
	// SendPhoneCodeTooFast = 302001
	302001: "잠시 후 다시 시도하세요.",
	// SendPhoneCodeLimit 限频
	//  SendPhoneCodeLimit = 302002
	302002: "잠시 후 다시 시도하세요.",
	// SendPhoneCodeFailed 发送失败
	//  SendPhoneCodeFailed = 302003
	302003: "초대코드 발송에 실패했습니다.",
	// SendPhoneCodeError 报错
	//  SendPhoneCodeError = 302004
	302004: "잠시 후 다시 시도하세요.",
	// ErrorShareCode  分享码错误
	//  ErrorShareCode = 501001
	501001: '잘못된 형식의 초대코드입니다.',
	// RequestTooOften 请求太频繁
	//  RequestTooOften = 501002
	501002: "잠시 후 다시 시도하세요.",
	// ShareSelf 无法分享自己
	//  ShareSelf = 501004
	501004: "자신에게 공유할 수 없습니다.",
	// GenerateShareCodeFail 生成分享码失败
	//  GenerateShareCodeFail = 501006
	501006: "초대코드 생성에 실패했습니다.",
	// ShortShareCodeAlreadyRecord    用户已被邀请过
	//  ShortShareCodeAlreadyRecord = 501007
	501007: '이미 초대된 유저입니다.',
	200007: '종료된 이벤트입니다.',
	default: '잠시 후 다시 시도하세요.'
}
const checkBackendStatus = (response: AxiosResponse) => {
	const { data } = response;
	if (!data) {
		return;
	}
	const { msg, code } = data;
	// 登录态失效
	if (code === 300001) {
		LOGIN.showLogin()
		window.location.reload()
		return;
	}
	if (code !== 0) {
		const text = BackendErroCode[code as keyof typeof BackendErroCode] || BackendErroCode.default  || msg
		window.showMessgae(text)
		return;
	}
};

export const initServetime = async () => {
	const now = new Date()
	const src = `https://hok-sg-act.playerinfinite.com/api/system/get_server_timestamp_and_update?t=` + now.getTime()
	await appendScript(src)
}

export function appendScript(script: string) {
	return new Promise((resolve, reject) => {
		const head = document.getElementsByTagName("head")[0];
		const wsScript = document.createElement("script");
		wsScript.type = "text/javascript";
		wsScript.src = script;
	
		head.appendChild(wsScript);
		const scriptLoaded = (e: Event) => {
			wsScript.removeEventListener("load", scriptLoaded);
			resolve(e);
		};
		const scriptLoadFailed = (e: Event) => {
			wsScript.removeEventListener("error", scriptLoadFailed);
			reject(e);
		};
		wsScript.addEventListener("load", scriptLoaded);
		wsScript.addEventListener("error", scriptLoadFailed);
		wsScript.addEventListener("abort", scriptLoadFailed);
	});
}